/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Request_FromInputs */

const en_agent_authorization_request_from = /** @type {(inputs: Agent_Authorization_Request_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorization request from`)
};

const zh_agent_authorization_request_from = /** @type {(inputs: Agent_Authorization_Request_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权请求来自`)
};

/**
* | output |
* | --- |
* | "Authorization request from" |
*
* @param {Agent_Authorization_Request_FromInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_request_from = /** @type {((inputs?: Agent_Authorization_Request_FromInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Request_FromInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_request_from(inputs)
	return zh_agent_authorization_request_from(inputs)
});
export { agent_authorization_request_from as "agent.authorization.request_from" }